import { Helmet } from "react-helmet";
import PageTitle from "../../common/PageTitle";
import { PureComponent } from "react";
import { connect } from "react-redux";
import RequesterStatistics from "./sub/Requester/RequesterStatistics";

interface StatisticsPageProps {
    user: { role: string };
}

class StatisticsPage extends PureComponent<StatisticsPageProps> {
    render() {
        const role = this.props.user.role;
        return (
            <>
                <Helmet>
                    <title>Turgoil - Statistika</title>
                    <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no" />
                </Helmet>
                {role === "Requester" && (
                    <>
                        <PageTitle>Ostustatistika</PageTitle>
                        <div className="statistics">
                            <RequesterStatistics />
                        </div>
                    </>
                )}

            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.userReducer.user,
    };
}

export default connect(mapStateToProps)(StatisticsPage);



